import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Loader } from '@opendoor/atoms/loader';
import { getBuyDirectCheckoutLayout } from 'components/buyer/buyDirectCheckout/BuyDirectCheckoutLayout';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';

import type { NextPageWithLayout } from '../_app';

/**
 * Dynamically import the checkout flow to code-split its heavy dependency tree
 * (XState, step components, sidebar, API clients) out of the main page bundle.
 * SSR is disabled because the flow requires authentication and is entirely client-driven.
 */
const BuyDirectCheckout = dynamic(
  () =>
    import('components/buyer/buyDirectCheckout/routes/BuyDirectCheckout').then(
      (mod) => mod.BuyDirectCheckout,
    ),
  {
    ssr: false,
    loading: () => (
      <Col className="items-center justify-center py-20">
        <Loader size="2xl" />
      </Col>
    ),
  },
);

/**
 * Buy Direct checkout page
 */
const BuyDirectCheckoutPage: React.FC = () => {
  const router = useRouter();
  const { addressId: addressIdParam } = router.query;
  const addressId = typeof addressIdParam === 'string' ? addressIdParam : undefined;

  return (
    <>
      <Head>
        <title>Buy Direct Checkout | Opendoor</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <BuyDirectCheckout addressId={addressId} />
    </>
  );
};

const BuyDirectCheckoutPageWithLayout = BuyDirectCheckoutPage as NextPageWithLayout & {
  theme?: string;
};
BuyDirectCheckoutPageWithLayout.getLayout = getBuyDirectCheckoutLayout;
BuyDirectCheckoutPageWithLayout.theme = 'novo';

export default BuyDirectCheckoutPageWithLayout;
